import { render, staticRenderFns } from "./ReadView.vue?vue&type=template&id=20fcd46a&scoped=true&"
import script from "./ReadView.vue?vue&type=script&lang=js&"
export * from "./ReadView.vue?vue&type=script&lang=js&"
import style0 from "./ReadView.vue?vue&type=style&index=0&id=20fcd46a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20fcd46a",
  null
  
)

export default component.exports